import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  MdImportantDevices,
  MdError,
  MdWarning,
  MdNote
} from 'react-icons/lib/md';
import NotificationSystem from 'react-notification-system';
import {
  exibirMensagem,
  fecharMensagem
} from "./actions";
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';

class Mensagem extends Component {

  componentWillReceiveProps({ mensagens: { exibir, icone, tipo, msg } }) {
    if (exibir) {
      const Icone = icone
        || tipo === ("error" && MdError)
        || (tipo === "warning" && MdWarning)
        || (tipo === "info" && MdNote)
        || MdImportantDevices;
      this.notificationSystem.addNotification({
        autoDismiss: 5,
//        title: <Icone />,
        message: msg,
        level: tipo,
        position: 'tc',
        onRemove: this.props.fecharMensagem
      });
    }
  }

  render() {
    return (
      <NotificationSystem
        ref={notificationSystem =>
          (this.notificationSystem = notificationSystem)
        }
        style={NOTIFICATION_SYSTEM_STYLE}
      />
    );
  }
}

const mapStateToProps = state => ({
  mensagens: state.mensagem.mensagens
})

const mapDispatchToProps = dispatch => bindActionCreators({
  exibirMensagem,
  fecharMensagem
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Mensagem))


// WEBPACK FOOTER //
// ./src/componentes/mensagem/index.js